<template>
    <div class="library_card_a">
        <div class="library_card_layout_div">
            <p class="library_card_title_p no_margin">{{ data.name }}</p>
            <p :class="data.description?'library_card_chapter_p no_margin':'not_show'">{{ data.description }}</p>
        </div>
        <div class="library_card_img_layout_div"
             v-for="(skill_info, index) in star[data.id]"
             :key="index">
            <div class="library_card_img_include_select_div">
                <div>
                    <img :title="skill_state==='hr'?star_info_list[Math.abs(index-4)]:star_info_list_common[Math.abs(index-4)]" :data-index="index" :data-skill-id="data.id" :src="skill_info['star']" class="skill_star_img" :data-state='data.state'>
                </div>
                <div>
                    <select class="skill_star_select" :data-index="index" :data-state='data.state' :data-skill-id="data.id" :style="skill_info['star']==star_on_img ? 'display: none' : ''" @change="set_skill_plan($event)">
                        <option :value ="years[0]" :selected="skill_info['year']==years[0] ? 1: ''"></option>
                        <option :value ="years[1]" :selected="skill_info['year']==years[1] ? 1: ''">{{years[1]}}</option>
                        <option :value ="years[2]" :selected="skill_info['year']==years[2] ? 1: ''">{{years[2]}}</option>
                        <option :value ="years[3]" :selected="skill_info['year']==years[3] ? 1: ''">{{years[3]}}</option>
                    </select>
                </div>
            </div>
        </div>
    </div>
</template>
<script type="text/javascript">
import { mapState, mapActions  } from 'vuex'

export default {
    props: {
        data: {
            type: Object,
            require: true
        }
    },
    data: function () {
        return {
            skill_state: '',
        }
    },
    computed: {
        ...mapState({
            star: state => state.skill_plan.star,
            star_on_img: state => state.skill_plan.star_on_img,
            star_off_img: state => state.skill_plan.star_on_img,
            star_blue_img: state => state.skill_plan.star_blue_img,
            years: state=> state.skill_plan.years,
            star_info_list: state => state.skill.star_info_list,
            star_info_list_common: state => state.skill.star_info_list_common,
        })
    },
    methods: {
        ...mapActions({
            load_star: 'skill_plan/load_star',
            click_star: 'skill_plan/click_star',
            set_skill_plan: 'skill_plan/set_skill_plan',
        })
    },
    mounted: function () {
        this.skill_state = localStorage.getItem('field')
    }

}
</script>
<style type="text/css" scoped>
.library_card_a {
    border: 1px solid #eee;
    box-shadow: 0 1px 2px 0 #d2d2d2;
    padding: 11px 13px;
    margin-bottom: 32px;
}

.library_card_a:hover {
    box-shadow: 0 2px 8px 0 #d2d2d2;
}

.library_card_img_layout_div {
    display: inline;
    overflow: auto;
}
.library_card_img_include_select_div {
    display: inline-block;
    padding: 10px 13px 10px 0;
    vertical-align: top;
}

.skill_star_img {
    width: 50px;
    height: 50px;
    border-radius: 50%;
}
.skill_star_select {
    width: 50px;
    height: 20px;
}

.library_card_layout_div {
    flex-direction: column;
    justify-content: space-between;
}

.library_card_title_p {
    font-size: 16px;
    color: #565656;
    max-height: 45px;
    overflow: hidden;
    word-break: break-word;
    text-overflow: ellipsis;
}

.library_card_chapter_p {
    font-size: 14px;
    color: #666;
}

.no_margin {
    margin: 0;
}
.not_show {
    display: none;
}

</style>
